import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";
import NewsCard from "../NewsCard";
import { ArrowRight } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsTeaser() {
  const { t, lang } = useI18n();
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/news`, { params: { limit: 3 } })
      .then((r) => setNews(r.data.slice(0, 3)))
      .catch((e) => console.error(e));
  }, []);

  return (
    <section
      id="news"
      data-testid="news-section"
      className="bg-white py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-5">{t.news.overline}</p>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#0A1428] leading-[1.1] tracking-tight font-medium">
              {t.news.title}
            </h2>
            <p className="mt-6 text-[#4A5568] text-lg leading-relaxed">
              {t.news.subtitle}
            </p>
          </div>
          <Link
            to="/news"
            data-testid="news-view-all"
            className="btn-secondary self-start"
          >
            {t.news.viewAll}
            <ArrowRight size={16} weight="bold" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((n) => (
            <NewsCard key={n.id} article={n} lang={lang} />
          ))}
        </div>
      </div>
    </section>
  );
}
